module.exports = __webpack_public_path__ + "static/media/zachary_lau.968b5091.jpg";